import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const partners = [{
  name: "USHL",
  logo: "https://dbhockeyadvancement.com/wp-content/uploads/2026/03/NCAA_logo.svg_-scaled.png?v=j6o2990ml9k"
}, {
  name: "NAHL",
  logo: "https://dbhockeyadvancement.com/wp-content/uploads/2026/03/USHL_Logo.svg_.png?v=mmoctbjyx8"
}, {
  name: "NCAA",
  logo: "https://dbhockeyadvancement.com/wp-content/uploads/2026/03/Quebec_Major_Junior_Hockey_League.svg_.png?v=itmv7ay9kb"
}, {
  name: "OHL",
  logo: "https://dbhockeyadvancement.com/wp-content/uploads/2026/03/Logo_OHL.svg_.png?v=7vmvzg21ykf"
}, {
  name: "WHL",
  logo: "https://dbhockeyadvancement.com/wp-content/uploads/2026/03/3.png?v=pehlds7vsq"
}, {
  name: "QMJHL",
  logo: "https://dbhockeyadvancement.com/wp-content/uploads/2026/03/4-1.png?v=z1le08jevki"
}, {
  name: "BCHL",
  logo: "https://dbhockeyadvancement.com/wp-content/uploads/2026/03/5.png?v=j1ytc0pvh8"
}, {
  name: "NCDC",
  logo: "https://dbhockeyadvancement.com/wp-content/uploads/2026/03/ncdc_logo.png?v=mivho2gsia"
}];
export default function Logos() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="19887" id="logos" className="bg-background py-24 border-t border-border">
      <div className="container mx-auto px-6 md:px-12">
        <div ref={ref} className={cn("grid grid-cols-2 md:grid-cols-4 gap-x-20 gap-y-20 items-center justify-items-center transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          {partners.map((partner, i) => <div key={i} data-index={i} className="w-full flex items-center justify-center group">
              <img src={partner.logo} alt={`${partner.name} logo`} className="max-w-[160px] md:max-w-[200px] h-auto object-contain grayscale opacity-30 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-500 ease-in-out filter brightness-110" />
            </div>)}
        </div>
      </div>
    </section>;
}